module.exports = "<br>\n<div fxLayout=\"row\" fxLayoutAlign=\"center start\">\n    <mat-card fxFlex=\"50%\">\n        <p>There is nothing to show on this page yet! But there is plenty of changes to follow at <a href=\"https://github.com/BruhnoMus/bruhno.com\">my githup rep.</a></p>\n    </mat-card>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/change-log/change-log.component.html
// module id = ../../../../../src/app/change-log/change-log.component.html
// module chunks = main